import { useContext } from "react";
import styled from "styled-components";
import { hideScrollBar } from "../../../../../../commonStyles";
import { useContainerSize } from "../../../../../../hooks/useContainerSize";
import { useAppSelector } from "../../../../../../redux";
import { getIsARepost } from "../../../../../../utils";
import { ModalContext } from "../../../../../Common/Modal";
import {
  PostCardContent,
  usePostCardContext,
} from "../../PostCard/PostCardContent";

export const PostContent = () => {
  const { processed_posts } = useAppSelector((store) => store.newsfeed);
  const { postId } = usePostCardContext();
  const { contentRef, maxContentHeight } = useContext(ModalContext);
  const { height: contentHeight } = useContainerSize(contentRef);
  const maxHeight = maxContentHeight - contentHeight - 80;

  const post = processed_posts[postId];
  const isARepost = getIsARepost(post.EmbedPostID);

  return (
    <Container $maxHeight={maxHeight}>
      <PostCardContent
        postId={isARepost ? post.EmbedPostID : postId}
        isWithinRepostModal={true}
      />
    </Container>
  );
};

const Container = styled.div<{ $maxHeight: number }>(
  ({ theme, $maxHeight }) => `
    border-radius: ${theme.radius["radius-xs"].value}rem;
    border: ${theme.border_width["border-width-thin"].value}rem solid ${theme.Color.border["ui-border-neutral"].value};
    padding: ${theme.spacing["spacing-2"].value}rem;
    max-height: ${$maxHeight}px;
    overflow-y: scroll;
    ${hideScrollBar};
`
);
